const SpinnerLoadingTypes = {
    SPINNER_LOADING_TYPE: "SPINNER_LOADING_TYPE"
}

export { SpinnerLoadingTypes };